import { render, staticRenderFns } from "./manageDetail.vue?vue&type=template&id=0a95b4cc&scoped=true&"
import script from "./manageDetail.vue?vue&type=script&lang=js&"
export * from "./manageDetail.vue?vue&type=script&lang=js&"
import style0 from "./manageDetail.vue?vue&type=style&index=0&id=0a95b4cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../ytht-h5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a95b4cc",
  null
  
)

export default component.exports